import PersonaDropdown from "shared/dropdowns/library-dropdown/persona/PersonaDropdown";
import { getEntityData } from "./relations/relations";
import { useItem } from "shared/dynamic-imports";

type Props = {
	disabled: boolean;
	recordType: "cem_cxopportunity" | "cem_cxactiontask" | "cem_cxsolution";
};

export default function PersonaRelations(props: Props): JSX.Element {
	const { recordType, disabled } = props;
	const { currentItem, handleChange } = useItem();
	const { functions } = getEntityData(recordType);

	const handleLink = (id: string) => {
		functions.link({ recEntityName: "cem_persona", recIds: [id], id: currentItem.id }); // link records in the backend
		handleChange("linkedPersonas", [...(currentItem?.linkedPersonas || []), id]);
	};
	const handleUnlink = (id: string) => {
		functions.unlink({ recEntityName: "cem_persona", recIds: [id], id: currentItem.id }); // unlink records in the backend
		handleChange(
			"linkedPersonas",
			currentItem?.linkedPersonas?.filter((relatedId: string) => relatedId !== id)
		); // update the state
	};
	const params = {
		object: currentItem,
		recordType,
		link: handleLink,
		unlink: handleUnlink,
		isSwitchDisabled: disabled,
	};

	return <PersonaDropdown {...params} />;
}
